import "UI/Widget/Forms/Control/Text";
/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Text
 */
UI.Widget.Forms.Control.Datetimepicker = Class(UI.Widget.Forms.Control.Text,
    /** @lends UI.Widget.Forms.Control.Datetimepicker.prototype */
    {
        insertElement: function() {
            this.ParentCall();

            var changeMonth = this.$control.attr("change-month") == "yes";
            var changeYear = this.$control.attr("change-year") == "yes";
            var yearRange = this.$control.attr("year-range");

            this.$element.datetimepicker({
                changeMonth: changeMonth,
                changeYear: changeYear,
                yearRange: yearRange,
                dateFormat: 'dd.mm.yy',
            });
        },

        removeElement: function() {
            this.$element.datetimepicker('destroy');

            this.ParentCall();
        },

        listenElement: function() {
            var self = this;
            var altFormat = Util.coalesce(this.$control.attr("alt-format"), "");

            this.$element.on("change", function() {
                if (this.value) {
                    self.setValue(altFormat ? moment(this.value, 'DD.MM.YYYY HH:mm:ss').format(altFormat) : this.value);
                } else {
                    self.setValue();
                }
            });
        },

        updateElement: function(value) {
            var altFormat = Util.coalesce(this.$control.attr("alt-format"), "");
            if (value) {
                value = altFormat ? moment(value, altFormat).format('DD.MM.YYYY HH:mm') : value;
            }
            this.Parent(value);
        }
    }
);
